import { useState, useMemo, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import FJModalClose from '../../FJModalClose/FJModalClose';
import classNames from 'classnames';
import styles from './FJTTVLibraryModal.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJTab from '../../../../common/components/FJTab/FJTab.jsx';
import FJConstant from '../../../../constants/FJConstant.js';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJVoiceItemContainer from '../../../FJTextToSpeech/FJTextToSpeechRight/container/FJVoiceItemContainer.jsx';
import FJSelectWithSearch from '../../../FJTextToVideo/FJVoiceSetting/FJSelectWithSearch/FJSelectWithSearch.jsx';
import FJFavorite from './FJFavorite.jsx';
import FJClone from './FJClone.jsx';
import FJAddIcon from '../../../../assets/svg/add.svg?react';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';

const headerTab = [
    {
        type: FJConstant.ALL,
        text: 'voice-library',
        isShow: true,
    },
    {
        type: FJConstant.INSTRUMENTAL,
        text: 'voice-cloning',
        isShow: true,
    },
    {
        type: FJConstant.INSTRUMENTAL,
        text: 'favorites',
        isShow: true,
    },
];
const FJTTVLibraryModal = props => {
    const {
        voiceList,
        favoriteVoiceList,
        voiceCloneList,
        onClose,
        onUse,
        languageList,
        onLanguageValueChange,
        languageValue,
        tabIndex,
        setTabIndex,
        loadingFavoriteListStatus,
        getFavorite,
        toCreateClone,
        createCloneStatus,
    } = props;

    const _scrollRef = useRef(null);
    const isLoadingRef = useRef(false);
    const [stateMaxCount, setStateMaxCount] = useState(30);

    useEffect(() => {
        _scrollRef.current.scrollTop(0);
    }, [languageValue]);

    useEffect(() => {
        _scrollRef.current.scrollTop(0);
    }, [tabIndex]);

    useEffect(() => {
        isLoadingRef.current = false;
    }, [stateMaxCount]);

    useEffect(() => {
        setStateMaxCount(30);
    }, [favoriteVoiceList.length]);
    const _onTotalScroll = () => {
        if (tabIndex === 2) {
            if (isLoadingRef.current) return;

            if (stateMaxCount < favoriteVoiceList.length) {
                isLoadingRef.current = true;
                setStateMaxCount(stateMaxCount + 30);
            }
        }
    };

    return (
        <div className={styles.box}>
            <FJModalClose onClick={onClose} />
            <div className={classNames(styles.content)}>
                <div className={styles.header}>
                    <div className={styles.title}>{FJLocalStore._('choose-voice')}</div>
                    {tabIndex === 0 && (
                        <div className={styles.search}>
                            <FJSelectWithSearch
                                list={languageList}
                                onLanguageValueChange={onLanguageValueChange}
                                value={languageValue}
                                zIndex={1001}
                                widthStyle={{ width: '320px' }}
                                searchStyle={{ width: '296px' }}
                            />
                        </div>
                    )}
                    {tabIndex === 1 && createCloneStatus === FJConstant.HISTORY_LIST && (
                        <FJButton
                            text='create-voice-clone'
                            type='gradient'
                            className={styles.btn}
                            icon={<FJAddIcon />}
                            onClick={toCreateClone}
                        />
                    )}
                </div>
                <div className={styles.header_tab}>
                    <FJTab
                        dataList={headerTab}
                        textClassName={styles.header_tab_text}
                        selectClassName={styles.header_tab_box}
                        lineClass={styles.line}
                        selectedIndex={tabIndex}
                        onChange={setTabIndex}
                    />
                </div>
                <div className={styles.content_box}>
                    <FJVerticalScroller className={styles.scroll_box} ref={_scrollRef} onTotalScroll={_onTotalScroll}>
                        {tabIndex === 0
                            ? voiceList.map(item => {
                                  return (
                                      <FJVoiceItemContainer
                                          key={item.value}
                                          info={item}
                                          fromType={item.type || FJConstant.MICROSOFT}
                                          onUse={onUse}
                                      />
                                  );
                              })
                            : null}
                        {tabIndex === 1 ? <FJClone voiceCloneList={voiceCloneList} onUse={onUse} /> : null}
                        {tabIndex === 2 ? (
                            <FJFavorite
                                favoriteVoiceList={favoriteVoiceList}
                                onUse={onUse}
                                loadingStatus={loadingFavoriteListStatus}
                                onRetry={getFavorite}
                                stateMaxCount={stateMaxCount}
                            />
                        ) : null}
                    </FJVerticalScroller>
                </div>
            </div>
        </div>
    );
};
FJTTVLibraryModal.propTypes = {
    voiceList: PropTypes.array,
    favoriteVoiceList: PropTypes.array,
    voiceCloneList: PropTypes.array,
    onClose: PropTypes.func,
    onUse: PropTypes.func,
    languageList: PropTypes.array,
    onLanguageValueChange: PropTypes.func,
    languageValue: PropTypes.string,
    tabIndex: PropTypes.number,
    setTabIndex: PropTypes.func,
    loadingFavoriteListStatus: PropTypes.string,
    getFavorite: PropTypes.func,
    toCreateClone: PropTypes.func,
    createCloneStatus: PropTypes.string,
};
export default FJTTVLibraryModal;
